var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftwareTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 7,
    fill: "#334456",
    stroke: "#334456",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 14.728H14.4C14.0686 14.728 13.8 14.9966 13.8 15.328C13.8 15.6594 14.0686 15.928 14.4 15.928H21.6C21.9314 15.928 22.2 15.6594 22.2 15.328C22.2 14.9966 21.9314 14.728 21.6 14.728Z",
    fill: "#FFF7E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.912 11.056H22C24.2091 11.056 26 12.8469 26 15.056V22.256C26 24.4651 24.2091 26.256 22 26.256H14C12.9391 26.256 11.9217 25.8346 11.1716 25.0844C10.4214 24.3343 10 23.3169 10 22.256V15.056C10 12.8469 11.7909 11.056 14 11.056H14.072V9.6C14.072 9.26863 14.3406 9 14.672 9C15.0034 9 15.272 9.26863 15.272 9.6V11.056H20.712V9.6C20.712 9.26863 20.9806 9 21.312 9C21.6434 9 21.912 9.26863 21.912 9.6V11.056ZM22 25.056C23.5464 25.056 24.8 23.8024 24.8 22.256V15.056C24.8 13.5096 23.5464 12.256 22 12.256H14C12.4536 12.256 11.2 13.5096 11.2 15.056V22.256C11.2 23.8024 12.4536 25.056 14 25.056H22Z",
    fill: "#FFF7E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareTwo);
export default __webpack_public_path__ + "static/media/software_two.8668b4a38e965165a11a7e451bfa8347.svg";
export { ForwardRef as ReactComponent };